$('document').ready(function () {
    // Check touch devices
    var checkMobile = function () {
        var isTouch = ('ontouchstart' in document.documentElement);
        if (isTouch) {
            $('html').addClass('touch');
        } else {
            $('html').addClass('no-touch');
        }
    };
    checkMobile();

    // Display messages as izitoadt
    refreshIziToastMessages();

    // Add to homescreen iOS
    //addToHomescreen();
});

let currentlyInSettings = false;

function navigateInPwa(state, step) {
    if (state !== undefined) {
        if (state == "input") {
            currentlyInSettings = false;
            dataLayer.push({
                'event': 'virtualPageView',
                'virtualPageView': '/step' + step
            });

            $('*[data-pwadisplay="settings"]').hide();
            if (step !== undefined && step) {
                $('*[data-pwadisplay="input"]').hide();
                $('*[data-pwadisplay="input"][data-step="' + step + '"]').show();
                currentStep = step;
            } else {
                $('*[data-pwadisplay="input"]').show();
            }

            $('.nav-step li').removeClass('active');
            $('.nav-step li').removeClass('completed');
            $('.nav-step').show();
            if (step == 1) {
                window.localStorage.setItem('step2Done', false);
                $('.collect-title h2').html($('.collect-title h2').data('step1'));
                if (window.localStorage.getItem('geolocalisationPopup') == 'authorized') {
                    getLocation();
                }
                $('.nav-step li.step-1').addClass('active');
            }
            if (step == 2) {
                $('.collect form input[name=accept-conditions-1],.collect form input[name=accept-conditions-2],.collect form input[name=accept-conditions-3]').prop('checked', false);
                $('.collect .collect-message-wrapper-2,.collect .collect-message-wrapper-3').addClass('has-disabled');
                $('.collect .collect-message-wrapper-3,.collect .collect-message-wrapper-2,.collect .collect-message-wrapper-1').removeClass('has-checked');
                $('.collect form input[name=accept-conditions-3]').change();

                $('.collect-title h2').html($('.collect-title h2').data('step2'));
                $('.nav-step li.step-1').addClass('completed');
                $('.nav-step li.step-2').addClass('active');
                refreshStep2();
            }
            if (step == 3) {
                $('.collect-title h2').html($('.collect-title h2').data('step3'));
                refreshStep3();
                $('.nav-step').hide();
            }

        } else if (state == "settings") {
            if (currentlyInSettings === true) {
                closeSettings();
                return;
            }

            dataLayer.push({
                'event': 'virtualPageView',
                'virtualPageView': '/settings'
            });
            $('*[data-pwadisplay="input"]').hide();
            refreshSettings();
            $('*[data-pwadisplay="settings"]').show();
            $('.collect-title h2').html($('.collect-title h2').data('config'));
            $('.nav-step').hide();
            currentlyInSettings = true;
        }
    }
}

function closeSettings() {
    navigateInPwa('input', currentStep);
}

function initFirstScreen() {
    collectAddresses = {'Luxembourg': {}}
    // Add addresses of Luxembourg city
    Object.keys(allCollectData.addresses).forEach(function (addressKey) {
        Object.keys(allCollectData.addresses[addressKey]).forEach(function (streetKey) {
            collectAddresses['Luxembourg'][allCollectData.addresses[addressKey][streetKey]] = addressKey;
        });
    });
    // Also add addresses of other cities
    Object.keys(allCollectData.otherAddresses).forEach(function (cityKey) {
        collectAddresses[cityKey] = {};
        Object.keys(allCollectData.otherAddresses[cityKey]).forEach(function (addressKey) {
            Object.keys(allCollectData.otherAddresses[cityKey][addressKey]).forEach(function (streetKey) {
                collectAddresses[cityKey][allCollectData.otherAddresses[cityKey][addressKey][streetKey]] = addressKey;
            });
        });
    });

    collectCities = {};
    Object.keys(allCollectData.cities).forEach(function (cityKey) {
        var relation = 'none';
        if (localitiesWithAddresses.indexOf(cityKey) !== -1) {
            relation = 'address';
        } else if (allCollectData.cities[cityKey] && Object.keys(allCollectData.cities[cityKey]).length > 1) {
            relation = 'tour';
        }
        collectCities[cityKey] = relation;
    });

    $.ajax({
        url: localEnv ? 'http://localhost:3004/' + currentLanguage + '/pwa' : 'https://www.valorlux.lu/' + currentLanguage + '/pwa',
       // url: 'http://localhost:3004/',
        type: 'GET',
        success: function (data) {
            $('.launchScreen').fadeOut(300, function () {
                $('.launchScreen').remove('')
            });
            $('#pwa-wrapper').html(data);

            initCollect();
            initwebapp();
            initMessaging();
        },
        error: function (data) {
            console.log('GOT ERROR : ', data)
        }
    });
}

function dismissOnInstallPopup(popupId) {
    var dismessElement = document.getElementById(popupId);
    if (dismessElement) {
        dismessElement.setAttribute('hidden', true);
    }
    document.getElementById('modals-container').setAttribute('hidden', true);
    document.getElementById('modal-backdrop').setAttribute('hidden', true);
}

function actionPopup(state) {
    if (state == 'dismisssettings') {
        closeSettings()
        return;
    } else if (state == 'authorized') {
        window.localStorage.setItem('geolocalisationPopup', 'authorized');
    } else if (state = 'dismiss') {
        window.localStorage.setItem('geolocalisationPopup', 'dismiss');
    }
    initFirstScreen();
}

var collectCity = false;
var collectTour = false;
var collectAddress = false;
var collectAddressText = false;
var dates = [];

var collectCities = {};
var collectAddresses = {};

// Validation form BS4
(function () {
    WebFont.load({
        google: {
            families: ['Maven+Pro:400,500,700']
        }
    });

    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);

    $('.special-navigate').click(function (e) {
        e.preventDefault();

        var navigationStep = $(this).data('pwadisplaytarget') == 'input' ? (currentStep ? currentStep : 1) : null;
        navigateInPwa($(this).data('pwadisplaytarget'), navigationStep);

        return false;
    })

   /* if (window.localStorage.getItem('allValorluxData')) {
        allCollectData = JSON.parse(window.localStorage.getItem('allValorluxData'));
        if (window.localStorage.getItem('geolocalisationPopup') == 'authorized') {
            setTimeout(
                function () {
                    initFirstScreen();
                }, 2000);
        } else {
            $('#modal-launch-screen').show()
        }
    } else {*/
        if (isFetchAPISupported()) {
            fetch(localEnv ? 'http://localhost:3004/manager/mod/valorlux/valorlux/all?lang=' + currentLanguage : 'https://www.valorlux.lu/manager/mod/valorlux/valorlux/all?v=110&lang=' + currentLanguage)
            .then(function(response) {
                return response.json();
            }).then(function(data) {
                allCollectData = data;
                window.localStorage.setItem('allValorluxData', JSON.stringify(data));
                if (window.localStorage.getItem('geolocalisationPopup') == 'authorized') {
                    setTimeout(
                      function () {
                          initFirstScreen();
                      }, 1500);
                } else {
                    $('#modal-launch-screen').show()
                }
            }).catch(function(error) {
                console.log('GOT ERROR IN FETCH : ', data)
            });

            fetch(localEnv ? 'http://localhost:3004/manager/mod/valorlux/quiz/quizpwa' : 'https://www.valorlux.lu/manager/mod/valorlux/quiz/quizpwa')
              .then(function(response) {
                  return response.json();
              }).then(function(data) {
                allQuizQuestions = data;
                window.localStorage.setItem('allQuizQuestions', JSON.stringify(data));
            }).catch(function(error) {
                console.log('GOT ERROR IN FETCH QUESTIONS : ', data)
            });
        } else {
            $.ajax({
                url: localEnv ? 'http://localhost:3004/manager/mod/valorlux/valorlux/all?lang=' + currentLanguage : 'https://www.valorlux.lu/manager/mod/valorlux/valorlux/all?lang=' + currentLanguage,
                type: 'GET',
                success: function (data) {
                    allCollectData = data;
                    window.localStorage.setItem('allValorluxData', JSON.stringify(data));
                    if (window.localStorage.getItem('geolocalisationPopup') == 'authorized') {
                        setTimeout(
                          function () {
                              initFirstScreen();
                          }, 1500);
                    } else {
                        $('#modal-launch-screen').show()
                    }
                },
                error: function (data) {
                    console.log('GOT ERROR : ', data)
                }
            });
            $.ajax({
                url: localEnv ? 'http://localhost:3004/manager/mod/quiz/quizpwa' : 'https://www.valorlux.lu/manager/mod/valorlux/quiz/quizpwa',
                type: 'GET',
                success: function (data) {
                    allQuizQuestions = data;
                    window.localStorage.setItem('allQuizQuestions', JSON.stringify(data));
                },
                error: function (data) {
                    console.log('GOT ERROR IN QUESTIONS : ', data)
                }
            });
        }
    //}
})();

